module.exports = __webpack_public_path__ + "static/img/fail.1d9ac43a.png";